var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as meetings } from '@web/lib/demo/data/meetingEvents';
import { getUsers } from '@web/lib/demo/utils';
import { MeetTimelineEventEnum, MeetType } from '@workalizer/shared';
import { calculateUserActivities, createTimelineData, createUserEventsMap } from '@workalizer/shared/services/getMeetByIdUtils';
export var getMeetById = function (input) {
    var _a, _b, _c, _d, _e;
    var meetingEvents = meetings.filter(function (event) { return event.id === input.meetId; });
    var meeting = (_a = meetingEvents[0]) === null || _a === void 0 ? void 0 : _a.meeting;
    if (!meeting) {
        return null;
    }
    var users = getUsers();
    var userEvents = createUserEventsMap(meetingEvents.map(function (event) {
        var _a;
        return (__assign(__assign({}, event), { date: new Date(event.date), action: event.action, user: (_a = users.find(function (user) { return user.id === event.userId; })) !== null && _a !== void 0 ? _a : users[0] }));
    }));
    var userActivities = calculateUserActivities(userEvents);
    var usersActivity = userActivities.map(function (_a) {
        var user = _a.user, events = _a.events, joinTime = _a.joinTime;
        var timelineData = events
            .map(function (event) { return createTimelineData(event, user); })
            .filter(function (data) { return data !== undefined; });
        if (joinTime) {
            timelineData.unshift({
                name: joinTime.toISOString(),
                time: joinTime.getTime(),
                user: user.name || user.email,
                type: MeetTimelineEventEnum.MEET_CALL_STARTED
            });
        }
        return {
            user: user,
            timelineData: timelineData
        };
    });
    var usersSummary = userActivities.map(function (_a) {
        var user = _a.user, duration = _a.duration, presentationCount = _a.presentationCount;
        return ({
            user: user,
            duration: Math.round(duration / 60),
            presentationCount: presentationCount
        });
    });
    var overrunSeconds = meeting.overrunDurationSeconds || 0;
    var plannedDurationSeconds = meeting.calendarId
        ? overrunSeconds > 0
            ? Math.max(60, meeting.durationSeconds - overrunSeconds)
            : meeting.id % 2 === 0
                ? meeting.durationSeconds + 600
                : meeting.durationSeconds
        : null;
    var organizerUser = meeting.organizerId
        ? users.find(function (user) { return user.id === meeting.organizerId; })
        : null;
    var presentGuests = meeting.meetingGuests.filter(function (guest) { return guest.isPresentAtMeeting; });
    var manHoursSeconds = userActivities.reduce(function (total, activity) { return total + activity.duration; }, 0);
    var presentationsCount = userActivities.reduce(function (total, activity) { return total + activity.presentationCount; }, 0);
    var timingDeltaSeconds = plannedDurationSeconds != null
        ? meeting.durationSeconds - plannedDurationSeconds
        : null;
    return {
        id: meeting.id,
        slugId: meeting.slugId,
        title: meeting.title,
        date: meeting.date,
        durationSeconds: meeting.durationSeconds,
        plannedDurationSeconds: plannedDurationSeconds,
        type: meeting.calendarId ? MeetType.Scheduled : MeetType.Unscheduled,
        organizer: organizerUser
            ? {
                id: organizerUser.id,
                name: organizerUser.name,
                email: organizerUser.email,
                orgUnitTitle: (_e = (_d = (_c = (_b = organizerUser.userOrgUnits) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.orgUnit) === null || _d === void 0 ? void 0 : _d.title) !== null && _e !== void 0 ? _e : null
            }
            : null,
        calendar: meeting.calendarId
            ? {
                title: meeting.title,
                isRecurring: false
            }
            : null,
        summary: {
            plannedDurationSeconds: plannedDurationSeconds,
            timingDeltaSeconds: timingDeltaSeconds,
            manHoursSeconds: manHoursSeconds,
            presentCount: presentGuests.length,
            invitedCount: meeting.meetingGuests.length,
            externalCount: presentGuests.filter(function (guest) { return guest.isExternal; }).length,
            presentationsCount: presentationsCount
        },
        usersActivity: usersActivity,
        usersSummary: usersSummary,
        createdAt: meeting.createdAt,
        updatedAt: meeting.updatedAt
    };
};
